import { render, staticRenderFns } from "./TenderDocList.vue?vue&type=template&id=78a89ee5&scoped=true&"
import script from "./TenderDocList.vue?vue&type=script&lang=js&"
export * from "./TenderDocList.vue?vue&type=script&lang=js&"
import style0 from "./TenderDocList.vue?vue&type=style&index=0&id=78a89ee5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a89ee5",
  null
  
)

export default component.exports